export const namespace = 'benchmarkdata'
